import { render, staticRenderFns } from "./EditApplicantProfile.vue?vue&type=template&id=5128ff6f&"
import script from "./EditApplicantProfile.vue?vue&type=script&lang=js&"
export * from "./EditApplicantProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports